const initialState = () => ({
  loading: false,
  fetched: false,
  data: {}
});

const ACTION_KEY = 'PATIENT_DETAIL_PEP';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        fetched: false
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        fetched: true
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return {
        ...state,
        loading: false,
        fetched: true,
        data: action.payload
      };
    }
    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
